webpackJsonp([6],{

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_plan_gratuitous_vue__ = __webpack_require__(772);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e826992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_plan_gratuitous_vue__ = __webpack_require__(988);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_plan_gratuitous_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e826992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_plan_gratuitous_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function data() {
	return {
		linkAppRunn: 'https://apprunn.com'
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-footer',
	data: data,
	props: {
		isJapi: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function data() {
	return {
		countries: [{
			name: 'Perú',
			city: 'Lima',
			phones: [( true ? '+51 940 637 220' + ' </br>' : '') + '\n\t\t\t\t\tCalle Independencia  106,</br>  \n\t\t\t\t\tPiso 10 Miraflores']
		}, {
			name: 'Ecuador',
			city: 'Latacunga',
			phones: ['PBX(03) 3730500 - +593 998514801' + '</br>\n\t\t\t\t\tAV.UNIDAD NACIONAL Y GABRIELA MISTRAL. EDIF FENIX CORP</br>\n\t\t\t\t\tMatriz Centro Tecnol\xF3gico Latacunga']
		}],
		linkInstagram: '',
		linkYoutube: 'https://www.youtube.com/channel/UCDPU662auHQsrZX7O2IBxVw',
		linkFb: 'https://www.facebook.com/casamarketapp',
		linkInstagramJapi: 'undefined',
		linkYoutubeJapi: 'https://www.youtube.com/channel/UCiZJj0qCZcM03CWwqJwbxNQ',
		linkFbJapi: 'https://www.facebook.com/Japisale'
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'company-data',
	data: data,
	props: {
		isJapi: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_footer_vue__ = __webpack_require__(463);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_619284ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__ = __webpack_require__(500);
function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-619284ef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_619284ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(499);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(435)("47db253e", content, true, {});

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(434)(true);
// imports


// module
exports.push([module.i, ".app-footer[data-v-619284ef]{background:#494949;color:#fff;line-height:24px;padding:70px 5%}@media (max-width:900px){.app-footer[data-v-619284ef]{padding:30px 3%}}.app-footer img[data-v-619284ef]{max-width:100%}.text-right[data-v-619284ef]{text-align:right}.title-footer[data-v-619284ef]{font-size:20px;line-height:30px;text-transform:uppercase}@media (max-width:900px){.title-footer[data-v-619284ef]{text-align:center}}.pa-16-desktop[data-v-619284ef]{padding:0 16px}.wrapper-text[data-v-619284ef]{font-size:16px}.btn-link[data-v-619284ef]{border-radius:8px;color:#fff;display:inline-block;padding:15px 60px;text-align:center;text-decoration:none;text-transform:uppercase;width:100%}.btn-blue[data-v-619284ef]{background-color:#005398}.btn-green[data-v-619284ef]{background-color:#02979b}.btn-mobile[data-v-619284ef]{display:none}@media (max-width:900px){.btn-mobile[data-v-619284ef]{display:block}}@media (max-width:900px){.btn-desktop[data-v-619284ef]{display:none}}@media (max-width:900px){.wrapper-logos[data-v-619284ef]{margin-bottom:45px}}.pa-20-desktop[data-v-619284ef]{padding-right:20%}@media (max-width:900px){.pa-20-desktop[data-v-619284ef]{padding-right:0}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home-new/app-footer.vue"],"names":[],"mappings":"AACA,6BACE,mBAAoB,AACpB,WAAe,AACf,iBAAkB,AAClB,eAAiB,CAClB,AACD,yBACA,6BACM,eAAiB,CACtB,CACA,AACD,iCACI,cAAgB,CACnB,AACD,6BACE,gBAAkB,CACnB,AACD,+BACE,eAAgB,AAChB,iBAAkB,AAClB,wBAA0B,CAC3B,AACD,yBACA,+BACM,iBAAmB,CACxB,CACA,AACD,gCACE,cAAgB,CACjB,AACD,+BACE,cAAgB,CACjB,AACD,2BACE,kBAAmB,AACnB,WAAe,AACf,qBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,qBAAsB,AACtB,yBAA0B,AAC1B,UAAY,CACb,AACD,2BACE,wBAA0B,CAC3B,AACD,4BACE,wBAA0B,CAC3B,AACD,6BACE,YAAc,CACf,AACD,yBACA,6BACM,aAAe,CACpB,CACA,AACD,yBACA,8BACI,YAAc,CACjB,CACA,AACD,yBACA,gCACI,kBAAoB,CACvB,CACA,AACD,gCACE,iBAAmB,CACpB,AACD,yBACA,gCACM,eAAiB,CACtB,CACA","file":"app-footer.vue","sourcesContent":["\n.app-footer[data-v-619284ef] {\n  background: #494949;\n  color: #ffffff;\n  line-height: 24px;\n  padding: 70px 5%;\n}\n@media (max-width: 900px) {\n.app-footer[data-v-619284ef] {\n      padding: 30px 3%;\n}\n}\n.app-footer img[data-v-619284ef] {\n    max-width: 100%;\n}\n.text-right[data-v-619284ef] {\n  text-align: right;\n}\n.title-footer[data-v-619284ef] {\n  font-size: 20px;\n  line-height: 30px;\n  text-transform: uppercase;\n}\n@media (max-width: 900px) {\n.title-footer[data-v-619284ef] {\n      text-align: center;\n}\n}\n.pa-16-desktop[data-v-619284ef] {\n  padding: 0 16px;\n}\n.wrapper-text[data-v-619284ef] {\n  font-size: 16px;\n}\n.btn-link[data-v-619284ef] {\n  border-radius: 8px;\n  color: #ffffff;\n  display: inline-block;\n  padding: 15px 60px;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  width: 100%;\n}\n.btn-blue[data-v-619284ef] {\n  background-color: #005398;\n}\n.btn-green[data-v-619284ef] {\n  background-color: #02979b;\n}\n.btn-mobile[data-v-619284ef] {\n  display: none;\n}\n@media (max-width: 900px) {\n.btn-mobile[data-v-619284ef] {\n      display: block;\n}\n}\n@media (max-width: 900px) {\n.btn-desktop[data-v-619284ef] {\n    display: none;\n}\n}\n@media (max-width: 900px) {\n.wrapper-logos[data-v-619284ef] {\n    margin-bottom: 45px;\n}\n}\n.pa-20-desktop[data-v-619284ef] {\n  padding-right: 20%;\n}\n@media (max-width: 900px) {\n.pa-20-desktop[data-v-619284ef] {\n      padding-right: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer"},[_c('v-layout',{staticClass:"container",attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"wrapper-logos",attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[(!_vm.isJapi)?_c('h2',{staticClass:"w-black title-footer pa-16-desktop"},[_vm._v("CASA MARKET llega gracias a Apprunn")]):_c('h2',{staticClass:"w-black title-footer pa-16-desktop"},[_vm._v("JAPISALE llega gracias a Apprunn")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"w-black pa-16-desktop"},[_vm._v("Nuestros productos y  principales clientes/partnes:")])]),_vm._v(" "),_c('v-layout',{staticClass:"pa-20-desktop",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('a',{attrs:{"href":"https://feedbackinn.com/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-feedbackinn.png","alt":"feedbackinn","height":"28"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('a',{attrs:{"href":"https://makipos.la/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-makipos.png","alt":"makipos","height":"28"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"text-right",class:[_vm.isJapi ? 'xs6' : 'xs4'],attrs:{"pa-2":""}},[_c('a',{attrs:{"href":"https://fenixcorp.net/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-fenix.png","alt":"fenix","height":"28"}})])]),_vm._v(" "),(!_vm.isJapi)?_c('v-flex',{staticClass:"text-right",attrs:{"xs4":"","pa-2":""}},[_c('a',{attrs:{"href":"https://japisale.com/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-japisale.png","alt":"japisale","height":"28"}})])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"text-right",class:[_vm.isJapi ? 'xs6' : 'xs4'],attrs:{"pa-2":""}},[(_vm.isJapi)?_c('a',{attrs:{"href":"https://casamarket.la/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/casa-market.svg","alt":"praktiko","height":"28"}})]):_c('img',{attrs:{"src":"/static/images-new/logos/logo-praktiko.png","alt":"praktiko","height":"28"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"wrapper-text",attrs:{"xs12":"","md4":""}},[_c('p',[_vm._v("Apprun es un Product Studio que tiene como misión \n\t\t\t\tcrear productos que ayuden a mejorar la vida de la gente .\n\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"btn-desktop",attrs:{"xs12":"","mt-5":"","pl-2":""}},[_c('a',{staticClass:"btn-link",class:[_vm.isJapi ? 'btn-blue' : 'btn-green'],attrs:{"href":_vm.linkAppRunn,"target":"_blank"}},[_vm._v("Visita Apprunn.com")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"btn-mobile",attrs:{"xs12":"","mt-3":"","text-xs-center":""}},[_c('a',{staticClass:"btn-link",class:[_vm.isJapi ? 'btn-blue' : 'btn-green'],attrs:{"href":_vm.linkAppRunn,"target":"_blank"}},[_vm._v("Visita Apprunn.com")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_data_vue__ = __webpack_require__(464);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38943509_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_data_vue__ = __webpack_require__(504);
function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38943509"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_data_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38943509_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_data_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(503);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(435)("78e1330a", content, true, {});

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(434)(true);
// imports


// module
exports.push([module.i, ".company-data[data-v-38943509]{color:#494949;font-size:16px;padding:98px 5%}@media (max-width:900px){.company-data[data-v-38943509]{padding:71px 53px 25px}}.title[data-v-38943509]{color:#ff6e1c;font-size:24px}.title-japi[data-v-38943509]{color:#005398;font-size:24px}.list-company[data-v-38943509]{list-style:none}.link-social-networks[data-v-38943509]{color:#494949;text-decoration:none}@media (max-width:900px){.logo[data-v-38943509]{height:57px;max-width:100%}}@media (max-width:900px){.wrapper-information[data-v-38943509]{margin-top:48px}}@media (max-width:900px){.text-information[data-v-38943509]{margin-bottom:43px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home-new/company-data.vue"],"names":[],"mappings":"AACA,+BACE,cAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,yBACA,+BACM,sBAA6B,CAClC,CACA,AACD,wBACE,cAAe,AACf,cAAgB,CACjB,AACD,6BACE,cAAe,AACf,cAAgB,CACjB,AACD,+BACE,eAAiB,CAClB,AACD,uCACE,cAAe,AACf,oBAAsB,CACvB,AACD,yBACA,uBACI,YAAa,AACb,cAAgB,CACnB,CACA,AACD,yBACA,sCACI,eAAiB,CACpB,CACA,AACD,yBACA,mCACI,kBAAoB,CACvB,CACA","file":"company-data.vue","sourcesContent":["\n.company-data[data-v-38943509] {\n  color: #494949;\n  font-size: 16px;\n  padding: 98px 5%;\n}\n@media (max-width: 900px) {\n.company-data[data-v-38943509] {\n      padding: 71px 53px 25px 53px;\n}\n}\n.title[data-v-38943509] {\n  color: #ff6e1c;\n  font-size: 24px;\n}\n.title-japi[data-v-38943509] {\n  color: #005398;\n  font-size: 24px;\n}\n.list-company[data-v-38943509] {\n  list-style: none;\n}\n.link-social-networks[data-v-38943509] {\n  color: #494949;\n  text-decoration: none;\n}\n@media (max-width: 900px) {\n.logo[data-v-38943509] {\n    height: 57px;\n    max-width: 100%;\n}\n}\n@media (max-width: 900px) {\n.wrapper-information[data-v-38943509] {\n    margin-top: 48px;\n}\n}\n@media (max-width: 900px) {\n.text-information[data-v-38943509] {\n    margin-bottom: 43px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"container company-data",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md5":"","xs12":""}},[_c('div',{staticClass:"mb-5"},[_c('a',{attrs:{"href":""}},[(_vm.isJapi)?_c('img',{staticClass:"logo",attrs:{"src":"/static/images-new/sections/logo-japi.svg","alt":"CasaMarket"}}):_c('img',{staticClass:"logo",attrs:{"src":"/static/images-new/logos/logo-casamarket.svg","alt":"CasaMarket"}})])]),_vm._v(" "),_c('div',{staticClass:"layout"},[(!_vm.isJapi)?_c('a',{staticClass:"mr-3",attrs:{"href":_vm.isJapi ? _vm.linkInstagramJapi : _vm.linkInstagram,"target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-instagram.svg","alt":"instagram"}})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"mr-3",attrs:{"href":_vm.isJapi ? _vm.linkYoutubeJapi : _vm.linkYoutube,"target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-youtube.svg","alt":"youtube"}})]),_vm._v(" "),_c('a',{staticClass:"mr-3",attrs:{"href":_vm.isJapi ? _vm.linkFbJapi : _vm.linkFb,"target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-facebook.svg","alt":"facebook"}})])])]),_vm._v(" "),_c('v-flex',{staticClass:"wrapper-information",attrs:{"md7":"","xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[(!_vm.isJapi)?_c('v-flex',{staticClass:"text-information",attrs:{"md4":"","xs12":"","pr-3":""}},[_c('p',{staticClass:"title w-bold"},[_vm._v("Empresa")]),_vm._v(" "),_c('ul',{staticClass:"list-company"},[_c('li',{staticClass:"mb-2"},[_c('a',{staticClass:"link-social-networks",attrs:{"href":"/market-place","target":"_blank"}},[_vm._v("Quiero comprar")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"link-social-networks",attrs:{"href":"https://quierovender.casamarket.la/","target":"_blank"}},[_vm._v("Quiero vender")])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.countries),function(country){return _c('v-flex',{key:country.name,staticClass:"text-information",attrs:{"md4":"","xs12":"","pr-3":""}},[_c('p',{staticClass:"w-bold",class:[ _vm.isJapi ? 'title-japi' : 'title']},[_vm._v("\n\t\t\t\t\t"+_vm._s(country.name)+"\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"mb-0 w-bold mb-2"},[_vm._v(_vm._s(country.city))]),_vm._v(" "),_c('div',_vm._l((country.phones),function(phone){return _c('div',{key:phone,domProps:{"innerHTML":_vm._s(phone)}})}))])})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function linkPlan() {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	var regDeviceOne = /Android|webOS|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	var regDeviceTwo = /iPad|iPhone|iPod/;
	if (regDeviceOne.test(userAgent)) {
		return 'https://plans-pdf.s3.amazonaws.com/PLANES-MOBILE.pdf';
	} else if (regDeviceTwo.test(userAgent) && !window.MSStream) {
		return 'https://plans-pdf.s3.amazonaws.com/PLANES-MOBILE.pdf';
	}
	return 'https://plans-pdf.s3.amazonaws.com/PLANES.pdf';
}

function data() {
	return {
		channels: [{
			id: 1,
			name: 'Tienda Online',
			image: '/static/images-new/icons/channel-1.svg'
		}, {
			id: 2,
			name: 'Vende Productos o Servicios',
			image: '/static/images-new/icons/channel-2.svg'
		}, {
			id: 3,
			name: 'Vende por WhatsApp',
			image: '/static/images-new/icons/channel-3.svg'
		}, {
			id: 4,
			name: 'Web Responsive',
			image: '/static/images-new/icons/channel-2.svg'
		}, {
			id: 5,
			name: 'Opción de Delivery o recojo en tienda',
			image: '/static/images-new/icons/channel-5.svg'
		}, {
			id: 6,
			name: 'App para Gestionar tu Tienda Online',
			image: '/static/images-new/icons/channel-6.svg'
		}, {
			id: 7,
			name: 'Múltiples Medios de Pago',
			image: '/static/images-new/icons/channel-8.svg'
		}, {
			id: 8,
			name: 'Catálogo de productos con imágenes',
			image: '/static/images-new/icons/channel-9.svg'
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-sales-channels',
	data: data,
	computed: {
		linkPlan: linkPlan
	}
});

/***/ }),

/***/ 716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_sales_channels_vue__ = __webpack_require__(651);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d21a338_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_sales_channels_vue__ = __webpack_require__(719);
function injectStyle (ssrContext) {
  __webpack_require__(717)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d21a338"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_sales_channels_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d21a338_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_sales_channels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(718);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(435)("23ff9976", content, true, {});

/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(434)(true);
// imports


// module
exports.push([module.i, ".section-sales-channels[data-v-4d21a338]{background-color:#fff;padding:50px 12px 42px;position:relative}@media (min-width:936px){.section-sales-channels[data-v-4d21a338]{padding:70px 0 75px}}.title-section-sales[data-v-4d21a338]{font-size:28px;margin:0 auto;max-width:750px;position:relative}.card-channel[data-v-4d21a338]{background-color:#fff;border-radius:9px;box-shadow:0 2px 15px 0 rgba(0,0,0,.06);max-width:184px;padding:23px 16px}@media (max-width:936px){.card-channel[data-v-4d21a338]{align-items:center;background-color:#fff;border-radius:9px;border:1px solid #acdada;display:flex;flex-direction:row;padding:13px 18px 10px 10px}}.grid-channels[data-v-4d21a338]{display:grid;grid-gap:6px;grid-template-columns:auto auto;justify-content:center;margin-top:25px}@media (min-width:936px){.grid-channels[data-v-4d21a338]{grid-template-columns:auto auto auto auto;grid-gap:30px 21px;margin-top:45px}}.text-discount[data-v-4d21a338]{font-size:18px;margin:0 auto;max-width:382px}@media (min-width:936px){.text-discount[data-v-4d21a338]{font-size:19px}}.text-card-channel[data-v-4d21a338]{font-size:10px;margin:0 0 0 10px;text-align:left}@media (min-width:936px){.text-card-channel[data-v-4d21a338]{margin-top:24px;font-size:14px;text-align:center}}.img-card-channel[data-v-4d21a338]{height:24px}@media (min-width:936px){.img-card-channel[data-v-4d21a338]{height:42px}}.title-chanell-mobile[data-v-4d21a338]{font-size:18px;margin:0 auto;max-width:235px}.btn-plans[data-v-4d21a338]{border-radius:35.5px;color:#fff;font-size:16px;height:61px;width:171px!important}@media (min-width:936px){.btn-plans[data-v-4d21a338]{font-size:18px;width:191px!important}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home-new/section-sales-channels.vue"],"names":[],"mappings":"AACA,yCACE,sBAA0B,AAC1B,uBAA6B,AAC7B,iBAAmB,CACpB,AACD,yBACA,yCACM,mBAAuB,CAC5B,CACA,AACD,sCACE,eAAgB,AAChB,cAAe,AACf,gBAAiB,AACjB,iBAAmB,CACpB,AACD,+BACE,sBAA0B,AAC1B,kBAAmB,AACnB,wCAA6C,AAC7C,gBAAiB,AACjB,iBAAmB,CACpB,AACD,yBACA,+BACM,mBAAoB,AACpB,sBAAwB,AACxB,kBAAmB,AACnB,yBAA0B,AAC1B,aAAc,AACd,mBAAoB,AACpB,2BAA6B,CAClC,CACA,AACD,gCACE,aAAc,AACd,aAAc,AACd,gCAAiC,AACjC,uBAAwB,AACxB,eAAiB,CAClB,AACD,yBACA,gCAEM,0CAA2C,AAC3C,mBAAoB,AACpB,eAAiB,CACtB,CACA,AACD,gCACE,eAAgB,AAChB,cAAe,AACf,eAAiB,CAClB,AACD,yBACA,gCACM,cAAgB,CACrB,CACA,AACD,oCACE,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CAClB,AACD,yBACA,oCACM,gBAAiB,AACjB,eAAgB,AAChB,iBAAmB,CACxB,CACA,AACD,mCACE,WAAa,CACd,AACD,yBACA,mCACM,WAAa,CAClB,CACA,AACD,uCACE,eAAgB,AAChB,cAAe,AACf,eAAiB,CAClB,AACD,4BACE,qBAAsB,AACtB,WAAe,AACf,eAAgB,AAChB,YAAa,AACb,qBAAwB,CACzB,AACD,yBACA,4BACM,eAAgB,AAChB,qBAAwB,CAC7B,CACA","file":"section-sales-channels.vue","sourcesContent":["\n.section-sales-channels[data-v-4d21a338] {\n  background-color: #ffffff;\n  padding: 50px 12px 42px 12px;\n  position: relative;\n}\n@media (min-width: 936px) {\n.section-sales-channels[data-v-4d21a338] {\n      padding: 70px 0 75px 0;\n}\n}\n.title-section-sales[data-v-4d21a338] {\n  font-size: 28px;\n  margin: 0 auto;\n  max-width: 750px;\n  position: relative;\n}\n.card-channel[data-v-4d21a338] {\n  background-color: #ffffff;\n  border-radius: 9px;\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.06);\n  max-width: 184px;\n  padding: 23px 16px;\n}\n@media (max-width: 936px) {\n.card-channel[data-v-4d21a338] {\n      align-items: center;\n      background-color: white;\n      border-radius: 9px;\n      border: solid 1px #acdada;\n      display: flex;\n      flex-direction: row;\n      padding: 13px 18px 10px 10px;\n}\n}\n.grid-channels[data-v-4d21a338] {\n  display: grid;\n  grid-gap: 6px;\n  grid-template-columns: auto auto;\n  justify-content: center;\n  margin-top: 25px;\n}\n@media (min-width: 936px) {\n.grid-channels[data-v-4d21a338] {\n      grid-gap: 30px 21px;\n      grid-template-columns: auto auto auto auto;\n      grid-gap: 30px 21px;\n      margin-top: 45px;\n}\n}\n.text-discount[data-v-4d21a338] {\n  font-size: 18px;\n  margin: 0 auto;\n  max-width: 382px;\n}\n@media (min-width: 936px) {\n.text-discount[data-v-4d21a338] {\n      font-size: 19px;\n}\n}\n.text-card-channel[data-v-4d21a338] {\n  font-size: 10px;\n  margin: 0 0 0 10px;\n  text-align: left;\n}\n@media (min-width: 936px) {\n.text-card-channel[data-v-4d21a338] {\n      margin-top: 24px;\n      font-size: 14px;\n      text-align: center;\n}\n}\n.img-card-channel[data-v-4d21a338] {\n  height: 24px;\n}\n@media (min-width: 936px) {\n.img-card-channel[data-v-4d21a338] {\n      height: 42px;\n}\n}\n.title-chanell-mobile[data-v-4d21a338] {\n  font-size: 18px;\n  margin: 0 auto;\n  max-width: 235px;\n}\n.btn-plans[data-v-4d21a338] {\n  border-radius: 35.5px;\n  color: #ffffff;\n  font-size: 16px;\n  height: 61px;\n  width: 171px !important;\n}\n@media (min-width: 936px) {\n.btn-plans[data-v-4d21a338] {\n      font-size: 18px;\n      width: 191px !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-sales-channels",attrs:{"id":"beneficios"}},[_c('v-flex',{staticClass:"w-semibold primary--text title-chanell-mobile br-mobile",attrs:{"text-xs-center":""}},[_c('span',{staticClass:"secondary--text"},[_vm._v("¡No pierdas Ventas!")]),_vm._v(" Conoce los Beneficios de Tu Tienda Online Gratis")]),_vm._v(" "),_c('v-flex',{staticClass:"br-desktop title-section-sales secondary--text w-bold",attrs:{"text-xs-center":""}},[_vm._v("¡Con CasaMarket no pierdas Ventas! "),_c('span',{staticClass:"primary--text"},[_vm._v(" Ten tus productos integrados en todos los canales de venta ")])]),_vm._v(" "),_c('div',{staticClass:"grid-channels"},_vm._l((_vm.channels),function(card,index){return _c('v-layout',{key:index,staticClass:"card-channel",attrs:{"column":""}},[_c('v-flex',{attrs:{"text-xs-center":"","xs1":""}},[_c('img',{staticClass:"img-card-channel",attrs:{"src":card.image,"alt":""}})]),_vm._v(" "),_c('v-flex',{staticClass:"newwarning--text text-card-channel",attrs:{"xs10":""}},[_vm._v("\n\t\t\t\t\t"+_vm._s(card.name)+"\n\t\t\t\t")])],1)})),_vm._v(" "),_c('v-flex',{staticClass:"newwarning--text w-bold mt-5 text-discount",attrs:{"text-xs-center":""}},[_vm._v("\n\t\tConoce Nuestros Planes "),_c('br'),_vm._v(" Tenemos "),_c('span',{staticClass:"primary--text w-black"},[_vm._v("50% de descuento por lanzamiento")])]),_vm._v(" "),_c('v-flex',{staticClass:"mt-3",attrs:{"text-xs-center":""}},[_c('a',{staticClass:"href-depressed w-semibold",attrs:{"href":_vm.linkPlan,"target":"_blank"}},[_c('v-btn',{staticClass:"btn-plans ma-0 w-black",attrs:{"color":"orange","depressed":""}},[_vm._v("\n\t\t\t\tVER PLANES\n\t\t\t")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_new_banner_plan__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_new_company_data__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_new_app_footer__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_new_section_sales_channels__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_new_section_digital_allies__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_new_section_plans_grauitous__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_new_section_integral_management__ = __webpack_require__(984);
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-plan-gratuitous',
	components: {
		bannerPlan: __WEBPACK_IMPORTED_MODULE_0__components_home_new_banner_plan__["a" /* default */],
		companyData: __WEBPACK_IMPORTED_MODULE_1__components_home_new_company_data__["a" /* default */],
		appFooter: __WEBPACK_IMPORTED_MODULE_2__components_home_new_app_footer__["a" /* default */],
		sectionSalesChannels: __WEBPACK_IMPORTED_MODULE_3__components_home_new_section_sales_channels__["a" /* default */],
		sectionDigitalAllies: __WEBPACK_IMPORTED_MODULE_4__components_home_new_section_digital_allies__["a" /* default */],
		sectionIntegralManagement: __WEBPACK_IMPORTED_MODULE_6__components_home_new_section_integral_management__["a" /* default */],
		sectionPlansGrauitous: __WEBPACK_IMPORTED_MODULE_5__components_home_new_section_plans_grauitous__["a" /* default */]
	}
});

/***/ }),

/***/ 773:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function openModal() {
	var _this = this;

	this.linkPageIFrame = 'https://casamarket.la/activa-tu-catalogo#formulario';
	this.dialog = true;
	setTimeout(function () {
		_this.loading = false;
	}, 3000);
}

function closeModal() {
	this.dialog = false;
	this.loading = true;
	this.linkPageIFrame = '';
}

function created() {
	window.addEventListener('scroll', this.handleScroll);
}

function destroyed() {
	window.removeEventListener('scroll', this.handleScroll);
}

function handleScroll() {
	var bp = document.getElementsByClassName('banner-plan');
	var scrollHeight = bp[0].scrollHeight - 108;
	this.scrolled = window.scrollY > scrollHeight;
}

function data() {
	return {
		loading: true,
		dialog: false,
		linkPageIFrame: '',
		sectionBanners: [{
			id: 1,
			name: 'Sin costo de implementación'
		}, {
			id: 2,
			name: 'Sin costo por transacción'
		}, {
			id: 3,
			name: 'Sin costo de renovación'
		}],
		items: [{
			id: 1,
			image: '/static/images-new/banners/slider-1-free.png',
			text: '<p class="mb-0 w-semibold">Tu tienda Online Movil</p>\n\t\t\t\t\t\t\t<img src="/static/images-new/icons/whatsapp-border-white.svg" height="36" class="ml-2">',
			width: '55%'
		}, {
			id: 2,
			image: '/static/images-new/banners/slider-2-free.png',
			text: '<p class="mb-0 w-semibold">Tu tienda Online Movil</p>\n\t\t\t\t\t\t\t<img src="/static/images-new/icons/whatsapp-border-white.svg" height="36" class="ml-2">',
			width: '55%'
		}, {
			id: 3,
			image: '/static/images-new/banners/slider-3-free.png',
			text: '<p class="mb-0 w-semibold">Múltiples <br>medios de pagos</p>',
			width: '55%'
		}, {
			id: 4,
			image: '/static/images-new/banners/slider-4-free.png',
			text: '<p class="mb-0"><span class="w-semibold">\xBFPreocupado por el Delivery?</span><br>\n\t\t\t\t\tCon CasaMarket vende online y nuestros \n\t\t\t\t\taliados se encargan del reparto:</p>',
			width: '80%'
		}, {
			id: 5,
			image: '/static/images-new/sections/whatsapp.png',
			text: '<p class="mb-0"><span class="w-semibold">\xBFPreocupado por el Delivery?</span><br>\n\t\t\t\t\tCon CasaMarket vende online y nuestros \n\t\t\t\t\taliados se encargan del reparto:</p>',
			width: '80%'
		}],
		scrolled: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'banner-plan',
	data: data,
	created: created,
	destroyed: destroyed,
	methods: {
		openModal: openModal,
		closeModal: closeModal,
		handleScroll: handleScroll
	}
});

/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function data() {
	return {
		allies: [{
			id: 1,
			name: 'Ayudamos a incrementar tus ventas y fidelizar a tus clientes',
			image: '/static/images-new/icons/icon-allie-1.svg'
		}, {
			id: 2,
			name: 'Nuestros productos son muy sencillos de usar para ti y tus clientes',
			image: '/static/images-new/icons/icon-allie-2.svg'
		}, {
			id: 3,
			name: 'Hacemos más eficiente la gestión de tu Negocio',
			image: '/static/images-new/icons/channel-1.svg'
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-digital-allies',
	data: data
});

/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function data() {
	return {
		step: 0,
		sliderIndex: 0,
		slideStep: {
			imageStepOne: '/static/images-new/sections/celular-2.png',
			imageStepTwo: '/static/images-new/sections/whatsapp.png'
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-plans-grauitous',
	data: data
});

/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function changeShow(_ref) {
	var id = _ref.id;

	var index = this.integrations.findIndex(function (p) {
		return p.id === id;
	});
	if (index > -1) {
		this.integrations[index].show = !this.integrations[index].show;
	}
}

function whatsappLink() {
	var reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	if (reg.test(navigator.userAgent)) {
		return 'https://api.whatsapp.com/send?phone=' + '+51977424180' + '&text=Hola he visto el plan gratuito y deseo mas informaci\xF3n';
	}
	return 'https://web.whatsapp.com/send?phone=' + '+51977424180' + '&text=Hola he visto el plan gratuito y deseo mas informaci\xF3n';
}

function data() {
	return {
		integrations: [{
			id: 1,
			name: 'Venta Online',
			image: '/static/images-new/icons/image-int-1.svg',
			show: false,
			sections: [{
				id: 1,
				name: 'App Whitelabel'
			}, {
				id: 2,
				name: 'Ecommerce Web'
			}, {
				id: 3,
				name: 'MarketPlace'
			}, {
				id: 4,
				name: 'Tienda Virtual'
			}, {
				id: 5,
				name: 'WhatsApp Center'
			}]
		}, {
			id: 2,
			name: 'Facturación Electrónica',
			image: '/static/images-new/icons/image-int-2.svg',
			show: false,
			sections: [{
				id: 1,
				name: 'App /Web'
			}, {
				id: 2,
				name: 'Hadwares en punto de Venta'
			}, {
				id: 3,
				name: 'Sistema Cloud: AWS'
			}, {
				id: 4,
				name: 'Integrado a los canales de venta online/offline'
			}]
		}, {
			id: 3,
			name: 'Gestión de Negocio',
			image: '/static/images-new/icons/image-int-3.svg',
			show: false,
			sections: [{
				id: 1,
				name: 'Control de Stock'
			}, {
				id: 2,
				name: 'Gestión logística'
			}, {
				id: 3,
				name: 'Módulo de Compra/Venta/Proveedores'
			}, {
				id: 4,
				name: 'Modúlo de Tesorería Bancos/Caja'
			}, {
				id: 5,
				name: 'Reportes'
			}]
		}, {
			id: 4,
			name: 'Venta Tienda Física',
			image: '/static/images-new/icons/image-int-4.svg',
			show: false,
			sections: [{
				id: 1,
				name: 'App de Gestión'
			}, {
				id: 2,
				name: 'Módulo de Gestión de Mercadería: Reposición y Devolución'
			}, {
				id: 3,
				name: 'Módulo de Inventario: Incluye toma física'
			}, {
				id: 4,
				name: 'Sistema Cloud: AWS'
			}, {
				id: 5,
				name: 'Cierre de Caja'
			}, {
				id: 6,
				name: 'Reportes'
			}]
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-integral-management',
	data: data,
	computed: {
		whatsappLink: whatsappLink
	},
	methods: {
		changeShow: changeShow
	}
});

/***/ }),

/***/ 972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banner_plan_vue__ = __webpack_require__(773);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddae5056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banner_plan_vue__ = __webpack_require__(975);
function injectStyle (ssrContext) {
  __webpack_require__(973)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ddae5056"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banner_plan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddae5056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banner_plan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(974);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(435)("6d16cdf2", content, true, {});

/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(434)(true);
// imports


// module
exports.push([module.i, ".banner-plan[data-v-ddae5056]{background-color:#fff;padding:25px 0 33px}@media (min-width:936px){.banner-plan[data-v-ddae5056]{background-image:url(\"/static/images-new/banners/BANNER.png\");background-position:50%;background-size:cover;background-repeat:no-repeat;background-color:#fff;height:900px;padding:57px 8% 0;position:relative}}@media (min-width:1024px){.banner-plan[data-v-ddae5056]{padding:57px 10% 0}}.ml-50[data-v-ddae5056]{margin-left:80px}.title-banner[data-v-ddae5056]{margin:25px 0 0;font-size:20px;text-align:center}@media (min-width:936px){.title-banner[data-v-ddae5056]{font-size:30px;margin-top:50px;text-align:left}}.content-banner[data-v-ddae5056]{align-items:center;background-color:#fff;border-radius:9px;box-shadow:0 2px 11px 0 rgba(0,0,0,.08);display:flex;font-size:17px;margin-bottom:14px;padding:15px 45px 15px 30px;width:384px}@media (max-width:936px){.content-banner[data-v-ddae5056]{font-size:14px;padding:15px 33px 15px 25px;margin:0 0 14px;max-width:100%}}.content-banner[data-v-ddae5056]:first-child{margin-left:0!important}.mt-50[data-v-ddae5056]{margin-top:40px;display:flex;justify-content:center}.text-banner[data-v-ddae5056]{margin:0 auto;max-width:90%;text-align:center}@media (min-width:936px){.text-banner[data-v-ddae5056]{margin-left:9%;max-width:590px;text-align:left}}.btn-market[data-v-ddae5056]{border-radius:35.5px;color:#fff;font-size:12px;height:54px!important;padding:0 20px;width:80%!important}.btn-market .btn__content[data-v-ddae5056]{white-space:none!important}@media (min-width:936px){.btn-market[data-v-ddae5056]{font-size:16px;height:63px!important;margin-top:25px!important;width:389px!important}}.column-mobile[data-v-ddae5056]{align-items:flex-start;flex-direction:column}@media (max-width:936px){.center-mobile[data-v-ddae5056]{text-align:center}}@media (max-width:936px){.fs-20[data-v-ddae5056]{font-size:15px}}.link-wssp-banner[data-v-ddae5056]{border-radius:27px;background-color:#02979b;color:#fff;font-size:13px;padding:10px 22px;opacity:.95;max-width:280px}@media (min-width:936px){.link-wssp-banner[data-v-ddae5056]{font-size:22px;padding:12px 35px;max-width:465px}}.btn-wssp-mobile[data-v-ddae5056]{border-radius:0 15px 15px 0;background-color:#02979b;color:#fff;font-size:13px;padding:11px 20px;position:absolute;left:0;top:230px;width:280px}.text-orange[data-v-ddae5056]{color:#ff6e1c}.img-phone-banner-mobile[data-v-ddae5056]{position:relative;top:39px}@media (min-width:936px){.img-phone-banner-mobile[data-v-ddae5056]{height:69vw}}.content-image[data-v-ddae5056]{bottom:-7px;position:absolute;right:9%}.max-width-mobile[data-v-ddae5056]{width:100px}.container-iframe[data-v-ddae5056]{position:relative}.container-close[data-v-ddae5056],.container-iframe .btn__content[data-v-ddae5056]{background-color:#fff!important;box-shadow:-2px 4px 9px 0 rgba(0,0,0,.14)}.container-close[data-v-ddae5056]{border-radius:50%;position:absolute;right:10px;top:10px}.container-progrees[data-v-ddae5056]{align-items:center;display:flex;justify-content:center;height:600px}.text-image[data-v-ddae5056]{font-size:20px}@media (max-width:936px){.text-image[data-v-ddae5056]{font-size:12px}}.image-logo[data-v-ddae5056]{height:63px}@media (max-width:936px){.image-logo[data-v-ddae5056]{height:39px}}.desktop[data-v-ddae5056]{display:block}@media (max-width:936px){.desktop[data-v-ddae5056]{display:none}}.mobile[data-v-ddae5056]{display:none}@media (max-width:936px){.mobile[data-v-ddae5056]{display:block}}.image-slider[data-v-ddae5056]{max-width:100%;max-height:370px}.slider-btn[data-v-ddae5056]{background-color:#02979b;border-radius:0 15px 15px 0;color:#fff;display:flex;max-width:80%;padding:13px}.content-image-slider[data-v-ddae5056]{align-items:center;display:flex;justify-content:center;height:332px}.content-want[data-v-ddae5056]{text-align:left}@media (max-width:936px){.content-want[data-v-ddae5056]{text-align:center}}.banner-plan-header[data-v-ddae5056]{background-color:#fff;box-shadow:0 2px 7px 0 rgba(0,0,0,.05);display:none;padding:20px 4%;position:fixed;top:0;left:0;right:0;z-index:200}.banner-plan-header.scrolling[data-v-ddae5056]{display:block}.img-header[data-v-ddae5056]{height:47px}@media (max-width:936px){.img-header[data-v-ddae5056]{height:27px}}.btn-header[data-v-ddae5056]{background-color:#ff6e1c;border-radius:27px;color:#fff;text-transform:uppercase;padding:10px 15px}@media (max-width:936px){.btn-header[data-v-ddae5056]{font-size:12px;padding:8px}}.bold-text[data-v-ddae5056]{font-size:16px;font-weight:900}.border-r[data-v-ddae5056]{border-right:1px solid #fff}", "", {"version":3,"sources":["/opt/build/repo/src/components/home-new/banner-plan.vue"],"names":[],"mappings":"AACA,8BACE,sBAAwB,AACxB,mBAAuB,CACxB,AACD,yBACA,8BACM,8DAA+D,AAC/D,wBAA4B,AAC5B,sBAAuB,AACvB,4BAA6B,AAC7B,sBAAwB,AACxB,aAAc,AACd,kBAAsB,AACtB,iBAAmB,CACxB,CACA,AACD,0BACA,8BACM,kBAAwB,CAC7B,CACA,AACD,wBACE,gBAAkB,CACnB,AACD,+BACE,gBAAmB,AACnB,eAAgB,AAChB,iBAAmB,CACpB,AACD,yBACA,+BACM,eAAgB,AAChB,gBAAiB,AACjB,eAAiB,CACtB,CACA,AACD,iCACE,mBAAoB,AACpB,sBAA0B,AAC1B,kBAAmB,AACnB,wCAA6C,AAC7C,aAAc,AACd,eAAgB,AAChB,mBAAoB,AACpB,4BAA6B,AAC7B,WAAa,CACd,AACD,yBACA,iCACM,eAAgB,AAChB,4BAA6B,AAC7B,gBAAmB,AACnB,cAAgB,CACrB,CACA,AACD,6CACI,uBAA0B,CAC7B,AACD,wBACE,gBAAiB,AACjB,aAAc,AACd,sBAAwB,CACzB,AACD,8BACE,cAAe,AACf,cAAe,AACf,iBAAmB,CACpB,AACD,yBACA,8BACM,eAAgB,AAChB,gBAAiB,AACjB,eAAiB,CACtB,CACA,AACD,6BACE,qBAAsB,AACtB,WAAe,AACf,eAAgB,AAChB,sBAAwB,AACxB,eAAgB,AAChB,mBAAsB,CACvB,AACD,2CACI,0BAA6B,CAChC,AACD,yBACA,6BACM,eAAgB,AAChB,sBAAwB,AACxB,0BAA4B,AAC5B,qBAAwB,CAC7B,CACA,AACD,gCACE,uBAAwB,AACxB,qBAAuB,CACxB,AACD,yBACA,gCACI,iBAAmB,CACtB,CACA,AACD,yBACA,wBACI,cAAgB,CACnB,CACA,AACD,mCACE,mBAAoB,AACpB,yBAA0B,AAC1B,WAAa,AACb,eAAgB,AAChB,kBAAmB,AACnB,YAAc,AACd,eAAiB,CAClB,AACD,yBACA,mCACM,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CACtB,CACA,AACD,kCACE,4BAA6B,AAC7B,yBAA0B,AAC1B,WAAa,AACb,eAAgB,AAChB,kBAAmB,AACnB,kBAAmB,AACnB,OAAQ,AACR,UAAW,AACX,WAAa,CACd,AACD,8BACE,aAAe,CAChB,AACD,0CACE,kBAAmB,AACnB,QAAU,CACX,AACD,yBACA,0CACM,WAAa,CAClB,CACA,AACD,gCACE,YAAa,AACb,kBAAmB,AACnB,QAAU,CACX,AACD,mCACE,WAAa,CACd,AACD,mCACE,iBAAmB,CACpB,AAKD,mFAHI,gCAAmC,AACnC,yCAAiD,CASpD,AAPD,kCAEE,kBAAmB,AAEnB,kBAAmB,AACnB,WAAY,AACZ,QAAU,CACX,AACD,qCACE,mBAAoB,AACpB,aAAc,AACd,uBAAwB,AACxB,YAAc,CACf,AACD,6BACE,cAAgB,CACjB,AACD,yBACA,6BACM,cAAgB,CACrB,CACA,AACD,6BACE,WAAa,CACd,AACD,yBACA,6BACM,WAAa,CAClB,CACA,AACD,0BACE,aAAe,CAChB,AACD,yBACA,0BACM,YAAc,CACnB,CACA,AACD,yBACE,YAAc,CACf,AACD,yBACA,yBACM,aAAe,CACpB,CACA,AACD,+BACE,eAAgB,AAChB,gBAAkB,CACnB,AACD,6BACE,yBAA0B,AAC1B,4BAA6B,AAC7B,WAAe,AACf,aAAc,AACd,cAAe,AACf,YAAc,CACf,AACD,uCACE,mBAAoB,AACpB,aAAc,AACd,uBAAwB,AACxB,YAAc,CACf,AACD,+BACE,eAAiB,CAClB,AACD,yBACA,+BACM,iBAAmB,CACxB,CACA,AACD,qCACE,sBAA0B,AAC1B,uCAA4C,AAC5C,aAAc,AACd,gBAAiB,AACjB,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,WAAa,CACd,AACD,+CACI,aAAe,CAClB,AACD,6BACE,WAAa,CACd,AACD,yBACA,6BACM,WAAa,CAClB,CACA,AACD,6BACE,yBAA0B,AAC1B,mBAAoB,AACpB,WAAe,AACf,yBAA0B,AAC1B,iBAAmB,CACpB,AACD,yBACA,6BACM,eAAgB,AAChB,WAAa,CAClB,CACA,AACD,4BACE,eAAgB,AAChB,eAAiB,CAClB,AACD,2BACE,2BAAgC,CACjC","file":"banner-plan.vue","sourcesContent":["\n.banner-plan[data-v-ddae5056] {\n  background-color: white;\n  padding: 25px 0 33px 0;\n}\n@media (min-width: 936px) {\n.banner-plan[data-v-ddae5056] {\n      background-image: url(\"/static/images-new/banners/BANNER.png\");\n      background-position: center;\n      background-size: cover;\n      background-repeat: no-repeat;\n      background-color: white;\n      height: 900px;\n      padding: 57px 8% 0 8%;\n      position: relative;\n}\n}\n@media (min-width: 1024px) {\n.banner-plan[data-v-ddae5056] {\n      padding: 57px 10% 0 10%;\n}\n}\n.ml-50[data-v-ddae5056] {\n  margin-left: 80px;\n}\n.title-banner[data-v-ddae5056] {\n  margin: 25px 0 0 0;\n  font-size: 20px;\n  text-align: center;\n}\n@media (min-width: 936px) {\n.title-banner[data-v-ddae5056] {\n      font-size: 30px;\n      margin-top: 50px;\n      text-align: left;\n}\n}\n.content-banner[data-v-ddae5056] {\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 9px;\n  box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.08);\n  display: flex;\n  font-size: 17px;\n  margin-bottom: 14px;\n  padding: 15px 45px 15px 30px;\n  width: 384px;\n}\n@media (max-width: 936px) {\n.content-banner[data-v-ddae5056] {\n      font-size: 14px;\n      padding: 15px 33px 15px 25px;\n      margin: 0 0 14px 0;\n      max-width: 100%;\n}\n}\n.content-banner[data-v-ddae5056]:first-child {\n    margin-left: 0 !important;\n}\n.mt-50[data-v-ddae5056] {\n  margin-top: 40px;\n  display: flex;\n  justify-content: center;\n}\n.text-banner[data-v-ddae5056] {\n  margin: 0 auto;\n  max-width: 90%;\n  text-align: center;\n}\n@media (min-width: 936px) {\n.text-banner[data-v-ddae5056] {\n      margin-left: 9%;\n      max-width: 590px;\n      text-align: left;\n}\n}\n.btn-market[data-v-ddae5056] {\n  border-radius: 35.5px;\n  color: #ffffff;\n  font-size: 12px;\n  height: 54px !important;\n  padding: 0 20px;\n  width: 80% !important;\n}\n.btn-market .btn__content[data-v-ddae5056] {\n    white-space: none !important;\n}\n@media (min-width: 936px) {\n.btn-market[data-v-ddae5056] {\n      font-size: 16px;\n      height: 63px !important;\n      margin-top: 25px !important;\n      width: 389px !important;\n}\n}\n.column-mobile[data-v-ddae5056] {\n  align-items: flex-start;\n  flex-direction: column;\n}\n@media (max-width: 936px) {\n.center-mobile[data-v-ddae5056] {\n    text-align: center;\n}\n}\n@media (max-width: 936px) {\n.fs-20[data-v-ddae5056] {\n    font-size: 15px;\n}\n}\n.link-wssp-banner[data-v-ddae5056] {\n  border-radius: 27px;\n  background-color: #02979b;\n  color: white;\n  font-size: 13px;\n  padding: 10px 22px;\n  opacity: 0.95;\n  max-width: 280px;\n}\n@media (min-width: 936px) {\n.link-wssp-banner[data-v-ddae5056] {\n      font-size: 22px;\n      padding: 12px 35px;\n      max-width: 465px;\n}\n}\n.btn-wssp-mobile[data-v-ddae5056] {\n  border-radius: 0 15px 15px 0;\n  background-color: #02979b;\n  color: white;\n  font-size: 13px;\n  padding: 11px 20px;\n  position: absolute;\n  left: 0;\n  top: 230px;\n  width: 280px;\n}\n.text-orange[data-v-ddae5056] {\n  color: #ff6e1c;\n}\n.img-phone-banner-mobile[data-v-ddae5056] {\n  position: relative;\n  top: 39px;\n}\n@media (min-width: 936px) {\n.img-phone-banner-mobile[data-v-ddae5056] {\n      height: 69vw;\n}\n}\n.content-image[data-v-ddae5056] {\n  bottom: -7px;\n  position: absolute;\n  right: 9%;\n}\n.max-width-mobile[data-v-ddae5056] {\n  width: 100px;\n}\n.container-iframe[data-v-ddae5056] {\n  position: relative;\n}\n.container-iframe .btn__content[data-v-ddae5056] {\n    background-color: white !important;\n    box-shadow: -2px 4px 9px 0px rgba(0, 0, 0, 0.14);\n}\n.container-close[data-v-ddae5056] {\n  background-color: white !important;\n  border-radius: 50%;\n  box-shadow: -2px 4px 9px 0px rgba(0, 0, 0, 0.14);\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.container-progrees[data-v-ddae5056] {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 600px;\n}\n.text-image[data-v-ddae5056] {\n  font-size: 20px;\n}\n@media (max-width: 936px) {\n.text-image[data-v-ddae5056] {\n      font-size: 12px;\n}\n}\n.image-logo[data-v-ddae5056] {\n  height: 63px;\n}\n@media (max-width: 936px) {\n.image-logo[data-v-ddae5056] {\n      height: 39px;\n}\n}\n.desktop[data-v-ddae5056] {\n  display: block;\n}\n@media (max-width: 936px) {\n.desktop[data-v-ddae5056] {\n      display: none;\n}\n}\n.mobile[data-v-ddae5056] {\n  display: none;\n}\n@media (max-width: 936px) {\n.mobile[data-v-ddae5056] {\n      display: block;\n}\n}\n.image-slider[data-v-ddae5056] {\n  max-width: 100%;\n  max-height: 370px;\n}\n.slider-btn[data-v-ddae5056] {\n  background-color: #02979b;\n  border-radius: 0 15px 15px 0;\n  color: #ffffff;\n  display: flex;\n  max-width: 80%;\n  padding: 13px;\n}\n.content-image-slider[data-v-ddae5056] {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 332px;\n}\n.content-want[data-v-ddae5056] {\n  text-align: left;\n}\n@media (max-width: 936px) {\n.content-want[data-v-ddae5056] {\n      text-align: center;\n}\n}\n.banner-plan-header[data-v-ddae5056] {\n  background-color: #ffffff;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.05);\n  display: none;\n  padding: 20px 4%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 200;\n}\n.banner-plan-header.scrolling[data-v-ddae5056] {\n    display: block;\n}\n.img-header[data-v-ddae5056] {\n  height: 47px;\n}\n@media (max-width: 936px) {\n.img-header[data-v-ddae5056] {\n      height: 27px;\n}\n}\n.btn-header[data-v-ddae5056] {\n  background-color: #ff6e1c;\n  border-radius: 27px;\n  color: #ffffff;\n  text-transform: uppercase;\n  padding: 10px 15px;\n}\n@media (max-width: 936px) {\n.btn-header[data-v-ddae5056] {\n      font-size: 12px;\n      padding: 8px;\n}\n}\n.bold-text[data-v-ddae5056] {\n  font-size: 16px;\n  font-weight: 900;\n}\n.border-r[data-v-ddae5056] {\n  border-right: 1px solid #ffffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-plan"},[_c('div',{staticClass:"banner-plan-header",class:{scrolling: _vm.scrolled}},[_c('v-layout',[_c('v-flex',{attrs:{"xs5":""}},[_c('img',{staticClass:"img-header",attrs:{"src":"/static/images-new/logos/logo-casamarket.svg","alt":"logo"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","text-xs-right":""}},[_c('button',{staticClass:"btn-header",on:{"click":_vm.openModal}},[_vm._v("Quiero tener mi tienda Online "),_c('span',{staticClass:"w-semibold"},[_vm._v("Gratis")])])])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"banner-main-container",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"center-mobile"},[_c('img',{staticClass:"image-logo",attrs:{"src":"/static/images-new/logos/logo-casamarket.svg","alt":"logo"}}),_vm._v(" "),_c('p',{staticClass:"newwarning--text text-image mb-0"},[_vm._v("Hacia la tranformación digital")])]),_vm._v(" "),_c('v-flex',{staticClass:"fs-20 w-semibold br-desktop",attrs:{"text-xs-right":""}},[_c('a',{staticClass:"white--text href-depressed",attrs:{"href":"#beneficios"}},[_vm._v("\n\t\t\t\t\tBENEFICIOS\n\t\t\t\t")]),_vm._v(" "),_c('a',{staticClass:"white--text href-depressed ml-50",attrs:{"href":"#sobre-casamarket"}},[_vm._v("\n\t\t\t\t\tSOBRE CASAMARKET\n\t\t\t\t")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-content",attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p',{staticClass:"w-semibold title-banner primary--text desktop"},[_vm._v("\n\t\t\t\t\tTienda Online "),_c('br'),_vm._v(" Gratis…. sí, leiste bien: "),_c('span',{staticClass:"text-orange w-bold"},[_vm._v("GRATIS!")])]),_c('p'),_c('p',{staticClass:"w-semibold title-banner primary--text mobile"},[_vm._v("\n\t\t\t\t\tTU tienda Online "),_c('span',{staticClass:"text-orange w-bold"},[_vm._v("GRATIS!")])]),_c('p'),_c('div',{staticClass:"mobile"},[_c('slider',{attrs:{"speed":2000,"interval":20000,"stop-on-hover":true,"animation":"fade","height":"368px"}},_vm._l((_vm.items),function(item){return _c('slider-item',{key:item.id},[_c('div',[(item.id === 1 || item.id === 2)?_c('div',{staticClass:"slider-btn"},[_c('v-layout',[_c('v-flex',{staticClass:"border-r",attrs:{"xs6":"","pr-1":""}},[_c('p',{staticClass:"bold-text mb-0"},[_vm._v("Tu tienda "),_c('br'),_vm._v(" Online "+_vm._s(item.id === 1 ? 'Móvil' : 'Web'))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pl-3":""}},[_c('p',{staticClass:"mb-0"},[_vm._v("Recibe\n\t\t\t\t\t\t\t\t\t\t\t\t"),_c('span',{staticClass:"w-semibold"},[_vm._v("tus pedidos")]),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t por Whatsapp\n\t\t\t\t\t\t\t\t\t\t\t\t "),_c('img',{staticClass:"ml-2",attrs:{"src":"/static/images-new/icons/whatsapp-border-white.svg","height":"17"}})])])],1)],1):(item.id === 5)?_c('div',{staticClass:"slider-btn"},[_c('v-layout',[_c('v-flex',{attrs:{"xs10":""}},[_c('p',{staticClass:"mb-0"},[_vm._v("Recibe "),_c('span',{staticClass:"w-semibold"},[_vm._v("tus pedidos")]),_vm._v(" por Whatsapp con todo el detalle.")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('img',{attrs:{"src":"/static/images-new/icons/whatsapp-border-white.svg","height":"36"}})])],1)],1):_c('div',{staticClass:"slider-btn",style:(("width: " + (item.width))),domProps:{"innerHTML":_vm._s(item.text)}}),_vm._v(" "),_c('div',{staticClass:"content-image-slider"},[_c('img',{staticClass:"image-slider",attrs:{"src":item.image,"alt":item.id,"height":item.id === 5? '265px' : 'auto'}})])])])}))],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-50 column-mobile desktop",attrs:{"text-xs-center":""}},_vm._l((_vm.sectionBanners),function(item,index){return _c('div',{key:index,staticClass:"content-banner"},[_c('div',[_c('img',{attrs:{"src":"/static/images-new/icons/check-orange.svg","height":"25","width":"25","alt":"check"}})]),_vm._v(" "),_c('div',{staticClass:"ml-2 w-medium"},[_vm._v(_vm._s(item.name))])])})),_vm._v(" "),_c('v-flex',{staticClass:"content-want"},[_c('v-btn',{staticClass:"btn-market ma-0 w-black btn-outline",attrs:{"color":"orange","depressed":""},on:{"click":_vm.openModal}},[_vm._v("\n\t\t\t\t\t\tQuiero tener mi tienda Online Gratis\n\t\t\t\t\t")])],1),_vm._v(" "),_c('p',{staticClass:"newwarning--text fs-14 text-banner w-medium"},[_vm._v("\n\t\t\t\t\tRegístrate y crea tu tienda online en 2 Pasos\n\t\t\t\t")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","text-xs-right":""}},[_c('div',{staticClass:"br-desktop"},[_c('button',{staticClass:"link-wssp-banner w-bold",on:{"click":_vm.openModal}},[_vm._v("\n\t\t\t\t\t\tVende en tu Tienda Online y recibe pedidos por WhatsApp\n\t\t\t\t\t\t"),_c('img',{staticClass:"ml-2",attrs:{"src":"/static/images-new/icons/whatsapp-border-white.svg","alt":"icono-whatsapp","height":"45"}})])]),_vm._v(" "),_c('div',{staticClass:"br-desktop content-image"},[_c('img',{staticClass:"img-phone-banner",attrs:{"src":"/static/images-new/sections/mano-banner-plan.png","alt":"image-telefono"}})])])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }return _vm.closeModal($event)}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"container-iframe"},[_c('div',{staticClass:"container-close"},[_c('v-btn',{attrs:{"depressed":"","flat":"","icon":""},on:{"click":_vm.closeModal}},[_c('img',{attrs:{"src":"/static/images-new/sections/close.svg","alt":"cerrar","height":"20"}})])],1),_vm._v(" "),_c('iframe',{staticStyle:{"border":"0px #ffffff none"},attrs:{"src":_vm.linkPageIFrame,"name":"myiFrame","scrolling":"no","frameborder":"1","marginheight":"0px","marginwidth":"0px","height":"600","width":"100%","allow":"geolocation","allowfullscreen":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"container-progrees"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"indeterminate":"","color":"teal darken-1"}})],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_digital_allies_vue__ = __webpack_require__(774);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f707e2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_digital_allies_vue__ = __webpack_require__(979);
function injectStyle (ssrContext) {
  __webpack_require__(977)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f707e2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_digital_allies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f707e2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_digital_allies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(978);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(435)("e5886ec2", content, true, {});

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(434)(true);
// imports


// module
exports.push([module.i, ".section-digital-allies[data-v-1f707e2e]{background-color:#f5fbfb;padding:90px 0}@media (max-width:936px){.section-digital-allies[data-v-1f707e2e]{padding:67px 38px 45px}}.item-allies[data-v-1f707e2e]{border-radius:9px;box-shadow:0 2px 15px 0 rgba(0,0,0,.06);background-color:#fff;margin-left:61px;max-width:184px;padding:25px 16px 28px;text-align:center}@media (max-width:936px){.item-allies[data-v-1f707e2e]{display:flex;align-items:center;margin:0 0 13px;max-width:100%}}.item-allies[data-v-1f707e2e]:first-child{margin-left:0}.content-allies[data-v-1f707e2e]{display:flex;justify-content:center;margin-top:79px}@media (max-width:936px){.content-allies[data-v-1f707e2e]{margin-top:30px;align-items:center;flex-direction:column}}.title-digital[data-v-1f707e2e]{color:#494949;font-size:18px}@media (min-width:936px){.title-digital[data-v-1f707e2e]{font-size:27px}}.allie-name[data-v-1f707e2e]{margin:0 0 0 22px;text-align:left}@media (min-width:936px){.allie-name[data-v-1f707e2e]{margin:30px 0 0;text-align:center}}.subtitle-digital[data-v-1f707e2e]{font-size:14px}@media (min-width:936px){.subtitle-digital[data-v-1f707e2e]{font-size:18px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home-new/section-digital-allies.vue"],"names":[],"mappings":"AACA,yCACE,yBAA0B,AAC1B,cAAgB,CACjB,AACD,yBACA,yCACM,sBAA6B,CAClC,CACA,AACD,8BACE,kBAAmB,AACnB,wCAA6C,AAC7C,sBAA0B,AAC1B,iBAAkB,AAClB,gBAAiB,AACjB,uBAA6B,AAC7B,iBAAmB,CACpB,AACD,yBACA,8BACM,aAAc,AACd,mBAAoB,AACpB,gBAAmB,AACnB,cAAgB,CACrB,CACA,AACD,0CACI,aAAe,CAClB,AACD,iCACE,aAAc,AACd,uBAAwB,AACxB,eAAiB,CAClB,AACD,yBACA,iCACM,gBAAiB,AACjB,mBAAoB,AACpB,qBAAuB,CAC5B,CACA,AACD,gCACE,cAAe,AACf,cAAgB,CACjB,AACD,yBACA,gCACM,cAAgB,CACrB,CACA,AACD,6BACE,kBAAmB,AACnB,eAAiB,CAClB,AACD,yBACA,6BACM,gBAAmB,AACnB,iBAAmB,CACxB,CACA,AACD,mCACE,cAAgB,CACjB,AACD,yBACA,mCACM,cAAgB,CACrB,CACA","file":"section-digital-allies.vue","sourcesContent":["\n.section-digital-allies[data-v-1f707e2e] {\n  background-color: #f5fbfb;\n  padding: 90px 0;\n}\n@media (max-width: 936px) {\n.section-digital-allies[data-v-1f707e2e] {\n      padding: 67px 38px 45px 38px;\n}\n}\n.item-allies[data-v-1f707e2e] {\n  border-radius: 9px;\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.06);\n  background-color: #ffffff;\n  margin-left: 61px;\n  max-width: 184px;\n  padding: 25px 16px 28px 16px;\n  text-align: center;\n}\n@media (max-width: 936px) {\n.item-allies[data-v-1f707e2e] {\n      display: flex;\n      align-items: center;\n      margin: 0 0 13px 0;\n      max-width: 100%;\n}\n}\n.item-allies[data-v-1f707e2e]:first-child {\n    margin-left: 0;\n}\n.content-allies[data-v-1f707e2e] {\n  display: flex;\n  justify-content: center;\n  margin-top: 79px;\n}\n@media (max-width: 936px) {\n.content-allies[data-v-1f707e2e] {\n      margin-top: 30px;\n      align-items: center;\n      flex-direction: column;\n}\n}\n.title-digital[data-v-1f707e2e] {\n  color: #494949;\n  font-size: 18px;\n}\n@media (min-width: 936px) {\n.title-digital[data-v-1f707e2e] {\n      font-size: 27px;\n}\n}\n.allie-name[data-v-1f707e2e] {\n  margin: 0 0 0 22px;\n  text-align: left;\n}\n@media (min-width: 936px) {\n.allie-name[data-v-1f707e2e] {\n      margin: 30px 0 0 0;\n      text-align: center;\n}\n}\n.subtitle-digital[data-v-1f707e2e] {\n  font-size: 14px;\n}\n@media (min-width: 936px) {\n.subtitle-digital[data-v-1f707e2e] {\n      font-size: 18px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-digital-allies",attrs:{"id":"sobre-casamarket"}},[_c('v-flex',{staticClass:"content-img mb-4",attrs:{"text-xs-center":""}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-casamarket.svg","alt":""}})]),_vm._v(" "),_c('v-flex',{staticClass:"w-medium newarning--text title-digital",attrs:{"text-xs-center":""}},[_vm._v("Nacemos con el propósito de ser "),_c('span',{staticClass:"w-bold primary--text"},[_vm._v("tus aliados digitales")])]),_vm._v(" "),_c('v-flex',{staticClass:"mt-4 newwarning--text subtitle-digital",attrs:{"text-xs-center":""}},[_vm._v("Atendemos todo tipo de empresas, brindando soluciones de venta online y gestión")]),_vm._v(" "),_c('div',{staticClass:"content-allies"},_vm._l((_vm.allies),function(allie,index){return _c('div',{key:index,staticClass:"item-allies"},[_c('img',{attrs:{"src":allie.image,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"primary--text fs-14 allie-name"},[_vm._v(_vm._s(allie.name))])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_plans_grauitous_vue__ = __webpack_require__(775);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d987d23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_plans_grauitous_vue__ = __webpack_require__(983);
function injectStyle (ssrContext) {
  __webpack_require__(981)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d987d23"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_plans_grauitous_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d987d23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_plans_grauitous_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(982);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(435)("860a66e6", content, true, {});

/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(434)(true);
// imports


// module
exports.push([module.i, ".section-plans-grauitous[data-v-2d987d23]{position:relative}.text-plans[data-v-2d987d23]{background-color:#e4f3f3;font-size:18px;padding:25px}@media (min-width:936px){.text-plans[data-v-2d987d23]{padding:35px 0;font-size:25px}}.content-step[data-v-2d987d23]{background-color:#f5fbfb;padding:36px 5%}@media (min-width:936px){.content-step[data-v-2d987d23]{padding:54px 10%}}.ft-text-manual[data-v-2d987d23]{font-size:20px}.type-name-plans[data-v-2d987d23]{font-size:12px}.content-plan[data-v-2d987d23]{background-color:#fff;border-radius:15px;box-shadow:0 2px 11px 0 rgba(0,0,0,.07);display:flex;font-size:12px;padding:22px 27px 22px 18px;width:100%}@media (min-width:936px){.content-plan[data-v-2d987d23]{align-items:center;flex-direction:column;height:139px;margin-left:0!important;max-width:139px;padding:17px 14px;text-align:center}}.width-100[data-v-2d987d23]{width:100%}.app-slider-plans[data-v-2d987d23]{background:transparent!important;height:595px!important}.text-orange[data-v-2d987d23]{color:#ff5c00}.text-step-one[data-v-2d987d23]{font-size:16px;margin:0 auto;max-width:200px}@media (min-width:936px){.text-step-one[data-v-2d987d23]{font-size:25px;text-align:center;max-width:100%}}.item-text-step[data-v-2d987d23]{margin-left:20px}@media (min-width:936px){.item-text-step[data-v-2d987d23]{margin:14px 0 0}}@media (max-width:936px){.img-step-one[data-v-2d987d23]{width:100%}}.content-step-one[data-v-2d987d23]{align-items:center;margin-top:30px;display:flex;justify-content:center}@media (max-width:936px){.content-step-one[data-v-2d987d23]{flex-direction:column}}@media (min-width:936px){.content-img-plans[data-v-2d987d23]{padding:0 36px}}.content-items-plans[data-v-2d987d23]{flex-direction:row}@media (min-width:936px){.content-items-plans[data-v-2d987d23]{flex-direction:column}}@media (max-width:936px){.img-step-two[data-v-2d987d23]{width:250px}}@media (max-width:936px){.text-post-plns[data-v-2d987d23]{max-width:238px;margin:0 auto}}.item-step-2[data-v-2d987d23]{left:18px;position:relative}.item-step-1[data-v-2d987d23]{right:18px;position:relative}@media (max-width:936px){.cont-three[data-v-2d987d23]{order:3}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home-new/section-plans-grauitous.vue"],"names":[],"mappings":"AACA,0CACE,iBAAmB,CACpB,AACD,6BACE,yBAA0B,AAC1B,eAAgB,AAChB,YAAc,CACf,AACD,yBACA,6BACM,eAAgB,AAChB,cAAgB,CACrB,CACA,AACD,+BACE,yBAA0B,AAC1B,eAAiB,CAClB,AACD,yBACA,+BACM,gBAAkB,CACvB,CACA,AACD,iCACE,cAAgB,CACjB,AACD,kCACE,cAAgB,CACjB,AACD,+BACE,sBAA0B,AAC1B,mBAAoB,AACpB,wCAA6C,AAC7C,aAAc,AACd,eAAgB,AAChB,4BAA6B,AAC7B,UAAY,CACb,AACD,yBACA,+BACM,mBAAoB,AACpB,sBAAuB,AACvB,aAAc,AACd,wBAA0B,AAC1B,gBAAiB,AACjB,kBAA6B,AAC7B,iBAAmB,CACxB,CACA,AACD,4BACE,UAAY,CACb,AACD,mCACE,iCAAmC,AACnC,sBAAyB,CAC1B,AACD,8BACE,aAAe,CAChB,AACD,gCACE,eAAgB,AAChB,cAAe,AACf,eAAiB,CAClB,AACD,yBACA,gCACM,eAAgB,AAChB,kBAAmB,AACnB,cAAgB,CACrB,CACA,AACD,iCACE,gBAAkB,CACnB,AACD,yBACA,iCACM,eAAmB,CACxB,CACA,AACD,yBACA,+BACI,UAAY,CACf,CACA,AACD,mCACE,mBAAoB,AACpB,gBAAiB,AACjB,aAAc,AACd,sBAAwB,CACzB,AACD,yBACA,mCACM,qBAAuB,CAC5B,CACA,AACD,yBACA,oCACI,cAAgB,CACnB,CACA,AACD,sCACE,kBAAoB,CACrB,AACD,yBACA,sCACM,qBAAuB,CAC5B,CACA,AACD,yBACA,+BACI,WAAa,CAChB,CACA,AACD,yBACA,iCACI,gBAAiB,AACjB,aAAe,CAClB,CACA,AACD,8BACE,UAAW,AACX,iBAAmB,CACpB,AACD,8BACE,WAAY,AACZ,iBAAmB,CACpB,AACD,yBACA,6BACI,OAAS,CACZ,CACA","file":"section-plans-grauitous.vue","sourcesContent":["\n.section-plans-grauitous[data-v-2d987d23] {\n  position: relative;\n}\n.text-plans[data-v-2d987d23] {\n  background-color: #e4f3f3;\n  font-size: 18px;\n  padding: 25px;\n}\n@media (min-width: 936px) {\n.text-plans[data-v-2d987d23] {\n      padding: 35px 0;\n      font-size: 25px;\n}\n}\n.content-step[data-v-2d987d23] {\n  background-color: #f5fbfb;\n  padding: 36px 5%;\n}\n@media (min-width: 936px) {\n.content-step[data-v-2d987d23] {\n      padding: 54px 10%;\n}\n}\n.ft-text-manual[data-v-2d987d23] {\n  font-size: 20px;\n}\n.type-name-plans[data-v-2d987d23] {\n  font-size: 12px;\n}\n.content-plan[data-v-2d987d23] {\n  background-color: #ffffff;\n  border-radius: 15px;\n  box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.07);\n  display: flex;\n  font-size: 12px;\n  padding: 22px 27px 22px 18px;\n  width: 100%;\n}\n@media (min-width: 936px) {\n.content-plan[data-v-2d987d23] {\n      align-items: center;\n      flex-direction: column;\n      height: 139px;\n      margin-left: 0 !important;\n      max-width: 139px;\n      padding: 17px 14px 17px 14px;\n      text-align: center;\n}\n}\n.width-100[data-v-2d987d23] {\n  width: 100%;\n}\n.app-slider-plans[data-v-2d987d23] {\n  background: transparent !important;\n  height: 595px !important;\n}\n.text-orange[data-v-2d987d23] {\n  color: #ff5c00;\n}\n.text-step-one[data-v-2d987d23] {\n  font-size: 16px;\n  margin: 0 auto;\n  max-width: 200px;\n}\n@media (min-width: 936px) {\n.text-step-one[data-v-2d987d23] {\n      font-size: 25px;\n      text-align: center;\n      max-width: 100%;\n}\n}\n.item-text-step[data-v-2d987d23] {\n  margin-left: 20px;\n}\n@media (min-width: 936px) {\n.item-text-step[data-v-2d987d23] {\n      margin: 14px 0 0 0;\n}\n}\n@media (max-width: 936px) {\n.img-step-one[data-v-2d987d23] {\n    width: 100%;\n}\n}\n.content-step-one[data-v-2d987d23] {\n  align-items: center;\n  margin-top: 30px;\n  display: flex;\n  justify-content: center;\n}\n@media (max-width: 936px) {\n.content-step-one[data-v-2d987d23] {\n      flex-direction: column;\n}\n}\n@media (min-width: 936px) {\n.content-img-plans[data-v-2d987d23] {\n    padding: 0 36px;\n}\n}\n.content-items-plans[data-v-2d987d23] {\n  flex-direction: row;\n}\n@media (min-width: 936px) {\n.content-items-plans[data-v-2d987d23] {\n      flex-direction: column;\n}\n}\n@media (max-width: 936px) {\n.img-step-two[data-v-2d987d23] {\n    width: 250px;\n}\n}\n@media (max-width: 936px) {\n.text-post-plns[data-v-2d987d23] {\n    max-width: 238px;\n    margin: 0 auto;\n}\n}\n.item-step-2[data-v-2d987d23] {\n  left: 18px;\n  position: relative;\n}\n.item-step-1[data-v-2d987d23] {\n  right: 18px;\n  position: relative;\n}\n@media (max-width: 936px) {\n.cont-three[data-v-2d987d23] {\n    order: 3;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 983:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-plans-grauitous"},[_c('v-flex',{staticClass:"w-semibold primary--text text-plans",attrs:{"text-xs-center":""}},[_vm._v("\n\t\t\t¡Con CasaMarket da el primer paso gratis! \n\t\t")]),_vm._v(" "),_c('div',{staticClass:"content-step"},[_c('v-flex',{staticClass:"secondary--text ft-text-manual w-bold",attrs:{"text-xs-center":""}},[_c('span',{staticClass:"text-orange w-semibold"},[_vm._v("Gratis")]),_vm._v(" y fácil de usar\n\t\t\t")]),_vm._v(" "),_c('v-stepper',{staticClass:"plans-stepper",model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-items',{staticClass:"plans-content"},[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('div',{staticClass:"content-step-one"},[_c('div',{staticClass:"content-plan "},[_c('img',{attrs:{"src":"static/images-new/icons/shop.svg","alt":"icon-shop"}}),_vm._v(" "),_c('span',{staticClass:"primary--text w-medium item-text-step"},[_vm._v("Crea tu tienda online en 2 Pasos ")])]),_vm._v(" "),_c('div',{staticClass:"mt-3 content-img-plans cont-three"},[_c('img',{staticClass:"img-step-one",attrs:{"src":_vm.slideStep.imageStepOne,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content-plan mt-4"},[_c('img',{attrs:{"src":"static/images-new/icons/box.svg","alt":"icon-box"}}),_vm._v(" "),_c('span',{staticClass:"primary--text w-medium item-text-step"},[_vm._v("\n\t\t\t\t\t\t\t\t\tOfrece tus Productos en tu Catálogo Virtual\n\t\t\t\t\t\t\t\t")])])])]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('div',{staticClass:"content-step-one",attrs:{"row":"","wrap":"","align-center":""}},[_c('div',{staticClass:"content-plan mt-4"},[_c('img',{attrs:{"src":"static/images-new/icons/smartphone.svg","alt":"icon-smartphone","height":"33"}}),_vm._v(" "),_c('span',{staticClass:"primary--text w-medium item-text-step"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tTu cliente realiza el pedido en tu tienda online\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"mt-4 content-img-plans cont-three",attrs:{"text-xs-center":""}},[_c('img',{staticClass:"img-step-two",attrs:{"src":_vm.slideStep.imageStepTwo,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content-plan mt-4"},[_c('v-layout',{staticClass:"content-items-plans",attrs:{"align-center":""}},[_c('v-flex',[_c('img',{attrs:{"src":"static/images-new/icons/whatsapp-orange.svg","alt":"icon-box","height":"33"}})]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text w-medium item-text-step"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tTe enviamos todo el detalle del pedido a tu WhatsApp\n\t\t\t\t\t\t\t\t\t")])],1)],1)])])],1),_vm._v(" "),_c('v-stepper-header',[_c('div',{staticClass:"stepper-header-container stepper__header justify-center"},[_c('v-stepper-step',{staticClass:"stepper__step--active-border item-step-1",class:{ 'active' : _vm.step === 1 },attrs:{"step":1,"editable":""}},[_vm._v("1")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{staticClass:"stepper__step--active-border item-step-2",attrs:{"step":2,"editable":""}},[_vm._v("2")])],1)]),_vm._v(" "),(_vm.step === 1)?_c('v-flex',{staticClass:"primary--text text-step-one w-medium mt-4",attrs:{"text-xs-center":""}},[_vm._v("\n\t\t\t\t\tDales el link de tu tienda online a "),_c('span',{staticClass:"text-orange w-bold"},[_vm._v("tus clientes")])]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('v-flex',{staticClass:"mt-4 w-medium primary--text text-post-plns",attrs:{"text-xs-center":""}},[_vm._v("\n\t\t\t\t\tRecibe "),_c('span',{staticClass:"text-orange w-bold"},[_vm._v("tus pedidos")]),_vm._v(" por Whatsapp "),_c('span',[_c('img',{attrs:{"src":"/static/images-new/icons/whatsapp-border-white.svg","alt":"icono-whatsapp","height":"45"}})]),_vm._v(" con todo el detalle.\n\t\t\t\t")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_integral_management_vue__ = __webpack_require__(776);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76f594ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_integral_management_vue__ = __webpack_require__(987);
function injectStyle (ssrContext) {
  __webpack_require__(985)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76f594ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_integral_management_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76f594ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_integral_management_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(986);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(435)("58bb1340", content, true, {});

/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(434)(true);
// imports


// module
exports.push([module.i, ".section-integral[data-v-76f594ab]{background-image:linear-gradient(180deg,#fff 17%,#f5fbfb);padding:70px 9% 30px}@media (min-width:986px){.section-integral[data-v-76f594ab]{padding:83px 10% 70px}}.item-integral[data-v-76f594ab]{border:3px solid #ff5c00;border-radius:35.5px;color:#ff5c00;margin-left:20px;padding:11px 0;text-align:center;width:285px}.item-integral[data-v-76f594ab]:first-child{margin-left:0}@media (max-width:936px){.item-integral[data-v-76f594ab]{align-items:center;color:#02979b;border:3px solid #02979b;display:flex;justify-content:space-between;margin-bottom:20px;padding:5px 20px 5px 10px;width:100%}}.content-items[data-v-76f594ab]{background-color:#fff;border-radius:19px;box-shadow:0 2px 6px 0 rgba(0,0,0,.12);height:auto;margin:5px 0 24px;padding:15px;width:100%}@media (min-width:936px){.content-items[data-v-76f594ab]{height:357px;margin-top:40px;padding:35px 15px 0 25px}}@media (min-width:936px){.mg-left[data-v-76f594ab]{margin-right:17px}}.image-integral[data-v-76f594ab]{bottom:40px;position:relative}.href-wssp[data-v-76f594ab]{background:#64b161;border-radius:25.5px;box-shadow:0 2px 6px 0 hsla(0,0%,62%,.5);color:#fff;padding:9px 9px 9px 22px;text-decoration:none;width:245px}.content-arrow[data-v-76f594ab]{bottom:40px;position:relative}@media (max-width:936px){.size-mobile[data-v-76f594ab]{font-size:18px}}.mobile-btn-arrow[data-v-76f594ab]{display:none}@media (max-width:936px){.mobile-btn-arrow[data-v-76f594ab],.show[data-v-76f594ab]{display:block}}@media (max-width:936px){.not-show[data-v-76f594ab]{display:none}}@media (max-width:936px){.select-section-plans[data-v-76f594ab]{border:2px solid #ff6e1c}}.name-integral[data-v-76f594ab]{margin-bottom:0;font-size:16px}@media (min-width:936px){.name-integral[data-v-76f594ab]{font-size:18px}}@media (max-width:936px){.title-plan-select[data-v-76f594ab]{color:#ff6e1c}}.title-integral[data-v-76f594ab]{font-size:14px}@media (min-width:936px){.title-integral[data-v-76f594ab]{font-size:27px}}.subtitle-integral[data-v-76f594ab]{font-size:12px}@media (min-width:936px){.subtitle-integral[data-v-76f594ab]{font-size:19px}}.rotate-icon[data-v-76f594ab]{transform:rotate(180deg)}", "", {"version":3,"sources":["/opt/build/repo/src/components/home-new/section-integral-management.vue"],"names":[],"mappings":"AACA,mCACE,0DAAmE,AACnE,oBAAyB,CAC1B,AACD,yBACA,mCACM,qBAA2B,CAChC,CACA,AACD,gCACE,yBAA0B,AAC1B,qBAAsB,AACtB,cAAe,AACf,iBAAkB,AAClB,eAAgB,AAChB,kBAAmB,AACnB,WAAa,CACd,AACD,4CACI,aAAe,CAClB,AACD,yBACA,gCACM,mBAAoB,AACpB,cAAe,AACf,yBAA0B,AAC1B,aAAc,AACd,8BAA+B,AAC/B,mBAAoB,AACpB,0BAA2B,AAC3B,UAAY,CACjB,CACA,AACD,gCACE,sBAA0B,AAC1B,mBAAoB,AACpB,uCAA4C,AAC5C,YAAa,AACb,kBAAqB,AACrB,aAAc,AACd,UAAY,CACb,AACD,yBACA,gCACM,aAAc,AACd,gBAAiB,AACjB,wBAA0B,CAC/B,CACA,AACD,yBACA,0BACI,iBAAmB,CACtB,CACA,AACD,iCACE,YAAa,AACb,iBAAmB,CACpB,AACD,4BACE,mBAAoB,AACpB,qBAAsB,AACtB,yCAAiD,AACjD,WAAe,AACf,yBAA0B,AAC1B,qBAAsB,AACtB,WAAa,CACd,AACD,gCACE,YAAa,AACb,iBAAmB,CACpB,AACD,yBACA,8BACI,cAAgB,CACnB,CACA,AACD,mCACE,YAAc,CACf,AAMD,yBACA,0DACI,aAAe,CAClB,CACA,AACD,yBACA,2BACI,YAAc,CACjB,CACA,AACD,yBACA,uCACI,wBAA0B,CAC7B,CACA,AACD,gCACE,gBAAiB,AACjB,cAAgB,CACjB,AACD,yBACA,gCACM,cAAgB,CACrB,CACA,AACD,yBACA,oCACI,aAAe,CAClB,CACA,AACD,iCACE,cAAgB,CACjB,AACD,yBACA,iCACM,cAAgB,CACrB,CACA,AACD,oCACE,cAAgB,CACjB,AACD,yBACA,oCACM,cAAgB,CACrB,CACA,AACD,8BACE,wBAA0B,CAC3B","file":"section-integral-management.vue","sourcesContent":["\n.section-integral[data-v-76f594ab] {\n  background-image: linear-gradient(to bottom, #ffffff 17%, #f5fbfb);\n  padding: 70px 9% 30px 9%;\n}\n@media (min-width: 986px) {\n.section-integral[data-v-76f594ab] {\n      padding: 83px 10% 70px 10%;\n}\n}\n.item-integral[data-v-76f594ab] {\n  border: solid 3px #ff5c00;\n  border-radius: 35.5px;\n  color: #ff5c00;\n  margin-left: 20px;\n  padding: 11px 0;\n  text-align: center;\n  width: 285px;\n}\n.item-integral[data-v-76f594ab]:first-child {\n    margin-left: 0;\n}\n@media (max-width: 936px) {\n.item-integral[data-v-76f594ab] {\n      align-items: center;\n      color: #02979b;\n      border: 3px solid #02979b;\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 20px;\n      padding: 5px 20px 5px 10px;\n      width: 100%;\n}\n}\n.content-items[data-v-76f594ab] {\n  background-color: #ffffff;\n  border-radius: 19px;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);\n  height: auto;\n  margin: 5px 0 24px 0;\n  padding: 15px;\n  width: 100%;\n}\n@media (min-width: 936px) {\n.content-items[data-v-76f594ab] {\n      height: 357px;\n      margin-top: 40px;\n      padding: 35px 15px 0 25px;\n}\n}\n@media (min-width: 936px) {\n.mg-left[data-v-76f594ab] {\n    margin-right: 17px;\n}\n}\n.image-integral[data-v-76f594ab] {\n  bottom: 40px;\n  position: relative;\n}\n.href-wssp[data-v-76f594ab] {\n  background: #64b161;\n  border-radius: 25.5px;\n  box-shadow: 0 2px 6px 0 rgba(158, 158, 158, 0.5);\n  color: #ffffff;\n  padding: 9px 9px 9px 22px;\n  text-decoration: none;\n  width: 245px;\n}\n.content-arrow[data-v-76f594ab] {\n  bottom: 40px;\n  position: relative;\n}\n@media (max-width: 936px) {\n.size-mobile[data-v-76f594ab] {\n    font-size: 18px;\n}\n}\n.mobile-btn-arrow[data-v-76f594ab] {\n  display: none;\n}\n@media (max-width: 936px) {\n.mobile-btn-arrow[data-v-76f594ab] {\n      display: block;\n}\n}\n@media (max-width: 936px) {\n.show[data-v-76f594ab] {\n    display: block;\n}\n}\n@media (max-width: 936px) {\n.not-show[data-v-76f594ab] {\n    display: none;\n}\n}\n@media (max-width: 936px) {\n.select-section-plans[data-v-76f594ab] {\n    border: 2px solid #ff6e1c;\n}\n}\n.name-integral[data-v-76f594ab] {\n  margin-bottom: 0;\n  font-size: 16px;\n}\n@media (min-width: 936px) {\n.name-integral[data-v-76f594ab] {\n      font-size: 18px;\n}\n}\n@media (max-width: 936px) {\n.title-plan-select[data-v-76f594ab] {\n    color: #ff6e1c;\n}\n}\n.title-integral[data-v-76f594ab] {\n  font-size: 14px;\n}\n@media (min-width: 936px) {\n.title-integral[data-v-76f594ab] {\n      font-size: 27px;\n}\n}\n.subtitle-integral[data-v-76f594ab] {\n  font-size: 12px;\n}\n@media (min-width: 936px) {\n.subtitle-integral[data-v-76f594ab] {\n      font-size: 19px;\n}\n}\n.rotate-icon[data-v-76f594ab] {\n  transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 987:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-integral"},[_c('v-flex',{staticClass:"newwarning--text title-integral",attrs:{"text-xs-center":""}},[_vm._v("Nuestra solución es un software de gestión integral para empresas, que incluye canales\n\t\t"),_c('span',{staticClass:"w-bold primary--text"},[_vm._v("Venta Online y Offline + Facturación Electrónica")])]),_vm._v(" "),_c('v-flex',{staticClass:"newwarning--text mt-3 subtitle-integral",attrs:{"text-xs-center":""}},[_vm._v("\n\t\tSi deseas contratar más productos, tenemos diversos planes para ayudarte\n\t")]),_vm._v(" "),_c('v-flex',{staticClass:"layout h-100 mt-5",attrs:{"mt-4":"","justify-center":"","wrap":""}},_vm._l((_vm.integrations),function(item,index){return _c('v-flex',{key:index,attrs:{"sm12":"","md3":""}},[_c('v-layout',{staticClass:"h-100 mg-left",attrs:{"align-center":"","column":""}},[_c('v-flex',{staticClass:"item-integral",class:{'select-section-plans': item.show},attrs:{"text-xs-center":""},on:{"click":function($event){_vm.changeShow(item)}}},[_c('div',{staticClass:"br-mobile",attrs:{"text-xs-left":"","xs2":""}},[_c('img',{attrs:{"src":item.image,"alt":"","height":"35px"}})]),_vm._v(" "),_c('p',{staticClass:"w-bold name-integral",class:{'title-plan-select': item.show},attrs:{"xs9":""}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"mobile-btn-arrow"},[_c('img',{class:{'rotate-icon': !item.show},attrs:{"src":"/static/images-new/sections/right-arrow.svg","alt":"flecha"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"content-items h-100",class:[item.show ? 'show' : 'not-show']},[_c('v-layout',{attrs:{"align-start":"","column":"","wrap":""}},_vm._l((item.sections),function(int,index){return _c('v-flex',{key:index,staticClass:"mb-2"},[_c('img',{attrs:{"src":"/static/images-new/icons/check-orange.svg","alt":"","height":"20"}}),_vm._v(" "),_c('span',{staticClass:"ml-2 fs-16 newwarning--text"},[_vm._v(_vm._s(int.name))])])}))],1),_vm._v(" "),_c('img',{staticClass:"image-integral br-desktop",attrs:{"src":item.image,"alt":"image-int"}})],1)],1)})),_vm._v(" "),_c('v-layout',{staticClass:"content-arrow",attrs:{"row":"","align-center":""}},[_c('v-flex',{staticClass:"br-desktop br-mobile"},[_c('img',{attrs:{"src":"/static/images-new/sections/arrow-left.svg","alt":""}})]),_vm._v(" "),_c('v-flex',{staticClass:"w-bold newwarning--text mt-5 size-mobile",attrs:{"text-xs-center":""}},[_vm._v("\n\t\t\tMedios de Pago y Soluciones Delivery\n\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"br-desktop br-mobile",attrs:{"ml-3":""}},[_c('img',{attrs:{"src":"/static/images-new/sections/arrow-right.svg","alt":""}})])],1),_vm._v(" "),_c('v-flex',{staticClass:"br-desktop",attrs:{"xs12":"","text-xs-center":"","mt-2":""}},[_c('a',{staticClass:"href-depressed",attrs:{"href":_vm.whatsappLink,"target":"_blank"}},[_c('button',{staticClass:"href-wssp w-bold"},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('img',{attrs:{"src":"/static/images-new/icons/whatsapp-white.svg","alt":""}})]),_vm._v(" "),_c('v-flex',{staticClass:"ml-3 text-wssp",attrs:{"text-xs-left":""}},[_vm._v("\n\t\t\t\t\t\tDeseo más información\n\t\t\t\t\t")])],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 988:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner-plan'),_vm._v(" "),_c('section-plans-grauitous'),_vm._v(" "),_c('section-sales-channels'),_vm._v(" "),_c('section-digital-allies'),_vm._v(" "),_c('section-integral-management'),_vm._v(" "),_c('company-data'),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.e9fe03eb671d5363b769.js